'use es6';

import mismatchedProperties from './pending/mismatchedProperties';
import isForbiddenAnalyticsFunnel from './pending/isForbiddenAnalyticsFunnel';
import * as DeprecationTypes from 'reporting-reports/deprecate/constants/deprecationTypes';
import DefaultDeprecationMessage from 'reporting-reports/deprecate/components/DefaultDeprecationMessage';
import freeAndStarterUsesDealSCP from './pending/freeAndStarterUsesDealSCP';
import campaignsContactAttribution from './pending/campaignsContactAttribution';
import usesCurrentlyInWorkflowContactProperty from './pending/usesCurrentlyInWorkflowContactProperty';
import { jsx as _jsx } from "react/jsx-runtime";
export const deprecations = {
  mismatchedProperties,
  isForbiddenAnalyticsFunnel,
  freeAndStarterUsesDealSCP,
  campaignsContactAttribution,
  usesCurrentlyInWorkflowContactProperty
};
export const isLockDownDeprecation = report => {
  return report.getIn(['deprecation', 'isDeprecated']) && report.getIn(['deprecation', 'type']) === DeprecationTypes.LOCK_DOWN_REPORT;
};
export const getDeprecationMessage = report => {
  const deprecationMessage = report.getIn(['deprecation', 'message']);
  return /*#__PURE__*/_jsx(DefaultDeprecationMessage, {
    message: deprecationMessage
  });
};